import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';


import { AppWrap, MotionWrap } from '../../wrapper';

import './About.scss';

import { images } from '../../constants';


const abouts = [
   {
    title: 'Web Developer', description: "I'm a web developer specializing in high-quality front-end development.", imgUrl: `${images.trophy}`},
   {
    title: 'Web Designer', description: "I'm a web designer who specializes in creating dynamic and beautiful web sites.", imgUrl: `${images.target}`
   },
   {
    title: 'UI/UX Designer', description: "I design for user experience, and also consider accessibility and performance.", imgUrl: `${images.puzzle}`
   },
   {
    title: 'Graphic Designer', description: "I'm designing Logos, Web banners, Photo manipulation, and any kind of graphic design.", imgUrl: `${images.pentool}`
   }
];

const About = () => {

  return (
    <>
      <h2 className='head-text'>
        I know That <span>Good Design</span><br /> means <span> Good Business </span>
      </h2>

      <div className='app__profiles'>
          { abouts.map((about, index) => (
            <motion.div
              whileInView={{ opacity: 1}}
              whileHover={{ scale: 1.1}}
              transition={{ druration: 0.5, type: 'tween' }}
              className='app__profile-item'
              key={about.title + index}
            >
              <img src={(about.imgUrl)} alt={about.title} />
              <h2 className='bold-text' style={{ marginTop: 20 }}>{about.title}</h2>
              <p className='p-text' style={{ marginTop: 10 }}>{about.description}</p>
            </motion.div>
          ))}
      </div>
    </>
  );
}

export default AppWrap(
  MotionWrap(About, 'app__about'), 
  'about', 
  );
